import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ShoppingBag } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useCart } from "@/contexts/CartContext";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { count } = useCart();
  const location = useLocation();
  const { t } = useTranslation();

  const NAV = [
    { to: "/", label: t("nav.home") },
    { to: "/menu", label: t("nav.menu") },
    { to: "/gallery", label: t("nav.gallery") },
    { to: "/blog", label: t("nav.blog") },
    { to: "/reservations", label: t("nav.reserve") },
    { to: "/contact", label: t("nav.contact") },
  ];

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 border-b"
      style={{ background: "rgba(255, 250, 239, 0.92)", backdropFilter: "blur(16px)", borderColor: "#E8D9BE", borderRadius: 0 }}
      data-testid="main-navbar"
    >
      <div className="container-tulsi flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="font-serif-display text-3xl text-gold-gradient leading-none">TULSI</span>
          <span className="hidden sm:inline text-xs tracking-[0.3em] uppercase text-[#A90011]">
            杜爾希
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {NAV.map((item, i) => (
            <Link
              key={item.to}
              to={item.to}
              data-testid={`nav-link-${i}`}
              className={`text-sm tracking-[0.15em] uppercase transition-colors ${
                location.pathname === item.to
                  ? "text-[#A90011]"
                  : "text-[#6B4A4E] hover:text-[#D11D21]"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <LanguageSwitcher />
          <Link
            to="/order"
            className="relative p-2 rounded-full hover:bg-[#FBEBD8] transition-colors"
            data-testid="cart-button"
          >
            <ShoppingBag size={20} className="text-[#A90011]" />
            {count > 0 && (
              <span className="absolute -top-1 -right-1 bg-[#D11D21] text-[#FFFAEF] text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center" data-testid="cart-count">
                {count}
              </span>
            )}
          </Link>
          <Link to="/reservations" className="hidden md:inline-flex">
            <button className="btn-saffron" data-testid="navbar-book-btn">{t("nav.book")}</button>
          </Link>
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden p-2 text-[#A90011]"
            data-testid="mobile-menu-btn"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t" style={{ borderColor: "#E8D9BE", background: "#FFFAEF" }} data-testid="mobile-menu">
          <div className="container-tulsi py-4 flex flex-col gap-3">
            {NAV.map((item, i) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${i}`}
                className="text-sm tracking-widest uppercase text-[#6B4A4E] py-2"
              >
                {item.label}
              </Link>
            ))}
            <Link to="/reservations" onClick={() => setOpen(false)}>
              <button className="btn-saffron w-full justify-center" data-testid="mobile-book-btn">{t("nav.book")}</button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
